const routes = [
    {
        path: '/functionalities-management',
        name: 'functionalities-management',
        component: () => import('@/modules/managers/functionalitiesManagement/FunctionalitiesManagement.vue')
    }
]

export default routes
